export default __webpack_public_path__ + "static/media/T160_CoC.fbecf8ba.pdf";